module.exports = __webpack_public_path__ + "img/ump-hover.79a9ade2.png";